import { AssetManager } from "realms-three-utils";
import { TextureAssetMap } from "./assetMaps/textures/textureAssetMap";
import { WeaponAssetMap } from "./assetMaps/weaponAssetMap";
import { TerrainAssetMap } from "./assetMaps/terrainMap";
import { GoblinAssetMap } from "./assetMaps/goblinAssetMap";
import { HelmetAssetMap } from "./assetMaps/helmetAssetMap";
import { BaseCharacterAssetMap } from "./assetMaps/base-character";

/**
 * All the assets to be loaded
 */
const MMOAssetMap = {
  ...TextureAssetMap,
  ...TerrainAssetMap,
  ...BaseCharacterAssetMap,
  ...WeaponAssetMap,
  ...GoblinAssetMap,
  ...HelmetAssetMap,
} as const;

export const MMOAssetManager = new AssetManager(MMOAssetMap);
